var map = {
	"./activity-icon-sm.svg": 77913,
	"./drugs-icon-sm.svg": 22888,
	"./glucose-empty.svg": 76017,
	"./glucose-icon-sm.svg": 84684,
	"./meal-icon-sm.svg": 40667,
	"./menu/activity-icon.svg": 80549,
	"./menu/blood-test.svg": 25048,
	"./menu/meal.svg": 43514,
	"./menu/tablets-icon.svg": 80465
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41856;